export const GET_USERS_LIST = 'GET_USERS_LIST';
export const GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS';
export const GET_USERS_LIST_FAILURE = 'GET_USERS_LIST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/get_users_list.constants.js